module.exports = __webpack_public_path__ + "img/corporategovernance-436x218-environmentalsustainability.2b7e0c90.jpg";